import { mapSignalsMessages } from '../mappers/signalMessages';
import {
	EditorialMessagePayload,
	Message,
	MessageResponse
} from '../models/signalMessages';

const fetcher = async (user, id: string): Promise<EditorialMessagePayload> => {
	try {
		const res = await fetch(
			`${process.env.REACT_APP_GATEWAY_URL}${window.config.Endpoints.SignalMessage}/${id}`,
			{
				method: 'GET',
				headers: {
					Accept: 'application/json',
					Authorization: `bearer ${user?.token}`
				}
			}
		);
		if (res.ok) {
			const data = await res.json();
			const arrayFromObj = [data];
			const mappedMessage = arrayFromObj.map((item: MessageResponse) =>
				mapSignalsMessages(item)
			) as Message[];
			return {
				data: mappedMessage,
				error: false
			} as EditorialMessagePayload;
		}
		return { data: null, error: false } as EditorialMessagePayload;
	} catch (error) {
		return { data: null, error: true };
	}
};

export async function getSignalsMessageById(user, id: string): Promise<EditorialMessagePayload> {
	return fetcher(user, id);
}
